import {
  IonButton,
} from "@ionic/react";
import React, { useEffect } from "react";
import { dataTransferService } from "../../../services/dataTransferService";
import { utilService } from "../../../services/utilService";
import { careTeamEmergencyAlertService } from "../CareTeamEmergencyAlert/CareTeamEmergencyAlert.service";
import "./EMSCareTeamAlertList.scss";

interface ContainerProps {
  patientInputParams: any;
  updateList: any;
  isFromCareTeamMembersAlert?: any;
}
const EMSCareTeamAlertList: React.FC<ContainerProps> = (props: any) => {
  useEffect(() => {
    if (props.patientInputParams.alert_status === "SENT") {
      let params = setCareTeamSeenParams();
      careTeamSeen(params);
    }
  }, [props.patientInputParams]);

  const setCareTeamSeenParams = () => {
    return {
      alert_id: props.patientInputParams.id,
      user_guid: utilService.getLoggedUserGuid(),
      response_type: "seen",
      reg_code: utilService.getNetwork(),
    };
  };

  async function careTeamSeen(params: any) {
    const resp: any = await careTeamEmergencyAlertService.careTeamAcceptData(
      params
    );
    if (resp.isSuccess) {
      dataTransferService.caseHistoryUpdatedAction(true);
    } else {
      console.log("error");
    }
  }

  const setCareTeamAcceptParams = () => {
    return {
      alert_id: props.patientInputParams.id,
      user_guid: utilService.getLoggedUserGuid(),
      response_type: "accepted",
      reg_code: utilService.getNetwork(),
    };
  };

  const careTeamAccept = () => {
    let params = setCareTeamAcceptParams();
    careTeamDataAccept(params);
  };

  async function careTeamDataAccept(params: any) {
    const resp: any = await careTeamEmergencyAlertService.careTeamAcceptData(
      params
    );
    if (resp.isSuccess) {
      props.updateList(props.patientInputParams.id);
      dataTransferService.caseHistoryUpdatedAction(true);
    } else {
      console.log("error");
    }
  }

  return (
    <>
      {props.isFromCareTeamMembersAlert && (
        <div className="ems-main-section">
          <div className="ems-main-container">
            <div className="ems-alert-label">
              <span className="label-ems">Care Team: </span>
              <span className="ems-alert-details">
                {props.patientInputParams &&
                  props.patientInputParams.care_team_name
                  ? props.patientInputParams.care_team_name
                  : ""}
              </span>
            </div>
            <div className="ems-alert-label">
              <span className="label-ems">Case Type: </span>

              <span className="ems-alert-details">
                {props.patientInputParams &&
                  props.patientInputParams.patient_case_types.length
                  ? props.patientInputParams.patient_case_types[0]
                  : "-Not selected-"}
                {props.patientInputParams &&
                  props.patientInputParams.patient_case_types.length >= 2
                  ? ` ( ${props.patientInputParams.patient_case_types.length} )`
                  : ""}
              </span>
            </div>

            <div className="alert-button-container">
              <div className="send-button-div">
                <IonButton
                  className="submit-btn button primary-btn btn-curved ems-alert-button"
                  onClick={() => {
                    careTeamAccept();
                  }}
                >
                  Ok
                </IonButton>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EMSCareTeamAlertList;
